import { InsightData } from 'schemas/action/InsightDataSchema'
import { DashboardWidgetWithPivotThemeType } from 'features/dashboard/types'
import { WidgetSettingComposingStrategy } from '../widgetSettingComposingStrategy'
import { DecoratedWidgetSettingComposingStrategy } from './type'

const hasProductBeenIncluded = (
  includedProductHierarchy: ((string | undefined)[] | undefined)[] | undefined,
  productName: string
) =>
  includedProductHierarchy &&
  includedProductHierarchy.some(
    (productHierarchy) =>
      productHierarchy && productHierarchy.length === 1 && productHierarchy.includes(productName)
  )

const pivotProductDecorator = (
  applicationSettings: any,
  strategy: WidgetSettingComposingStrategy
): DecoratedWidgetSettingComposingStrategy => ({
  ...strategy,
  canBeDrilledDown: (widgetSetting: DashboardWidgetWithPivotThemeType) => {
    if (
      widgetSetting.includedProductHierarchy &&
      widgetSetting.includedProductHierarchy.length >=
        applicationSettings.analysisProductHierarchyFilterCount
    ) {
      return false
    }

    return strategy.canBeDrilledDown(widgetSetting)
  },
  composeDrillDownWidgetSetting: (
    widgetSetting: DashboardWidgetWithPivotThemeType,
    insights: InsightData[],
    pivots: InsightData[]
  ) => {
    const alteredWidgetSetting = strategy.composeDrillDownWidgetSetting(widgetSetting, insights)
    const notIncludedProductName = pivots.filter(
      (pivot) => !hasProductBeenIncluded(alteredWidgetSetting.includedProductHierarchy, pivot.name!)
    )

    if (notIncludedProductName.length === 0) {
      return alteredWidgetSetting
    }

    return {
      ...alteredWidgetSetting,
      includedProductHierarchy: [
        ...(alteredWidgetSetting.includedProductHierarchy || []),
        notIncludedProductName.map((product) => product.name!)
      ]
    }
  }
})

export default pivotProductDecorator
